export default {
  list: [
    {
      id: 'a0737ca5-f191-4ca0-95c1-c729eac61951',
      legacy: 'front_desk_range',
      condition: 'hasLicense("Reports")',
    },
    {
      id: '4ee13dd7-bf63-4788-95df-b14968b20846',
      legacy: 'front_desk_range',
      condition: 'hasLicense("Reports")',
      params: {
        includeAdditionalServices: 1,
      },
    },
    {
      id: 'de987533-4fc4-45cd-8242-a194d54324bf',
      legacy: 'front_desk_range',
      condition: 'hasLicense("Reports")',
      params: {
        hideInternalComment: 1,
      },
    },
    {
      id: 'efcd8581-b78a-4d94-b071-3af35c56c86c',
      legacy: 'boarding_list_range',
      condition: 'hasLicense("Reports")',
    },
    {
      id: 'e426bb88-7729-4643-b471-eb58d8c48e50',
      legacy: 'boarding_list_summary_range',
      condition: 'hasLicense("Reports")',
    },
    {
      id: '7c163761-ec94-4f83-8df6-528021d417d6',
      legacy: 'meal_list_summary_range',
      condition: 'hasLicense("Reports")',
    },
    {
      id: 'a9546102-6170-497b-87b6-8111996f8311',
      legacy: 'front_desk_range',
      condition: 'hasLicense("Reports")',
      params: {
        hideName: 1,
      },
    },
    {
      id: 'da64c863-f9ef-481f-a83d-3f787de16112',
      legacy: 'front_desk_range',
      condition: 'hasLicense("Reports")',
      params: {
        hideName: 1,
        hideInternalComment: 1,
      },
    },
    {
      id: '66ee6900-4262-41ea-8baf-6cc08c68cb04',
      legacy: 'arrival_range',
      condition: 'hasLicense("Reports")',
    },
    {
      id: 'f4db0b31-d25e-4a34-b63e-aadfcf77686c',
      legacy: 'arrival_range',
      condition: 'hasLicense("Reports")',
      params: {
        hideInternalComment: 1,
      },
    },
    {
      id: '96d1a9b9-e70d-42f6-af75-aced547c40c4',
      legacy: 'departure_range',
      condition: 'hasLicense("Reports")',
    },
    {
      id: 'f07fe1c6-292f-4d10-aa0c-33538037feef',
      legacy: 'departure_range',
      condition: 'hasLicense("Reports")',
      params: {
        hideInternalComment: 1,
      },
    },
    {
      id: '1912be9e-abd8-41c3-9f9f-2f79c0fb3cc4',
      legacy: 'guest_birthday',
      condition: 'hasLicense("Reports")',
      dateRange: true,
      dayMonthOnly: true,
    },
    {
      id: '701f2b05-e487-452d-9429-821c4285d8b7',
      legacy: 'prepayment_awaiting',
      condition: 'hasLicense("Reports")',
      dateRange: false,
    },
    {
      id: 'ff69ac69-2dee-4ba8-bc7f-7b8c373d8c2d',
      legacy: 'meldeblatt_nationality',
      condition: 'hasLicense("InterfaceMeldeblatt") && hasLicense("Reports")',
    },
    {
      id: '11d7ff9a-779d-45ff-8389-7f0298de786c',
      legacy: 'meldeblatt_at_nationality',
      condition: 'hasLicense("InterfaceMeldeblatt") && hasLicense("Reports") && hotelSettings.details.countryCode === "AT"',
    },
    {
      id: '4b3fb55e-ab95-479d-a7c2-5fa8ceed73c3',
      legacy: 'meldeblatt_gastart',
      condition: 'hasLicense("InterfaceMeldeblatt") && hasLicense("Reports") && hotelSettings.details.countryCode === "AT"',
    },
    {
      id: 'fef8eef7-f525-43d8-9b8e-6e3634388c7c',
      legacy: 'guest_nationality_at',
      condition: 'hasLicense("Reports") && hotelSettings.details.countryCode === "AT"',
    },
    {
      id: 'dcf1bbfa-7504-40ae-9f14-5a197c5f05bc',
      legacy: 'guest_nationality',
      condition: 'hasLicense("Reports")',
    },
    {
      id: '96113c27-8bfd-4273-958d-b54b94882eb7',
      legacy: 'guest_nationality',
      condition: 'hasLicense("Reports")',
      params: {
        fallbackToAddress: 1,
      },
    },
    {
      id: '83e7d4ee-2e4a-4fee-9822-37a2bd883747',
      legacy: 'guest_nationality',
      condition: 'hasLicense("Reports")',
      params: {
        roomBasedReport: 1,
        fallbackToAddress: 1,
      },
    },
    {
      id: '6722f61a-c9ce-44e5-9a57-3dfab75a9230',
      legacy: 'on_request',
      condition: 'hasLicense("Reports")',
    },
    {
      id: '5561ef24-f8db-467d-9dc0-b151a96b338f',
      legacy: 'arrival_departure_statistics',
      condition: 'hasLicense("Reports")',
    },
    {
      id: '964f5cd2-e743-45aa-8dd7-566e559a2e65',
      legacy: 'occupancy_statistics',
      condition: 'hasLicense("Reports")',
    },
    {
      id: '24e24806-40c2-48a5-83ba-498b7adde102',
      legacy: 'occupancy_statistics_room',
      condition: 'hasLicense("Reports")',
    },
    {
      id: 'e1778962-0560-4066-b31f-0d0df25dc7c3',
      legacy: 'cancellations',
      condition: 'hasLicense("FinancialReports") && hasRole("ROLE_FINANCIAL_REPORTS")',
    },
    {
      id: 'ecb5e2c0-987e-45d9-89b4-d887be2a4e5d',
      legacy: 'cancellations',
      condition: 'hasLicense("FinancialReports") && hasRole("ROLE_FINANCIAL_REPORTS")',
      params: {
        byCancellationDate: 1,
      },
    },
    {
      id: 'fcf84fd8-b9a2-4065-9396-4affe64c5918',
      legacy: 'cancellations',
      condition: 'hasLicense("FinancialReports") && hasRole("ROLE_FINANCIAL_REPORTS")',
      params: {
        showNames: 1,
      },
    },
    {
      id: '624045f2-b7b2-44c8-8f91-79395ddd84ca',
      legacy: 'cancellations',
      condition: 'hasLicense("FinancialReports") && hasRole("ROLE_FINANCIAL_REPORTS")',
      params: {
        showNames: 1,
        byCancellationDate: 1,
      },
    },
    {
      id: 'cad8190c-6b5e-4cb5-90c2-af230aef8fad',
      legacy: 'payment_method',
      condition: 'hasLicense("FinancialReports") && hasRole("ROLE_FINANCIAL_REPORTS")',
    },
    {
      id: '768e7e12-3774-40e1-9c56-5b8b529d78d0',
      legacy: 'payment_method_transactionid',
      condition: 'hasLicense("FinancialReports") && hasRole("ROLE_FINANCIAL_REPORTS") && ["AT","DE"].includes(hotelSettings.details.countryCode)',
      params: {
        version: '2',
      },
    },
    {
      id: 'ce84a060-b8f8-4bb2-bc45-1f9751679796',
      legacy: 'payment_detail_list',
      condition: 'hasLicense("FinancialReports") && hasRole("ROLE_FINANCIAL_REPORTS")',
    },
    {
      id: 'a9d90780-86cd-4c5c-b0e4-5922ccee4b7a',
      legacy: 'payment_detail_only_list',
      condition: 'hasLicense("FinancialReports") && hasRole("ROLE_FINANCIAL_REPORTS")',
    },
    {
      id: 'a89fd3dd-d90e-48cb-946e-c7bc9d99cd90',
      legacy: 'open_balance',
      condition: 'hasLicense("FinancialReports") && hasRole("ROLE_FINANCIAL_REPORTS")',
      dateRange: false,
    },
    {
      id: '4b171130-cca9-48eb-b3cc-ab341f77fe9f',
      legacy: 'open_balance_invoices',
      condition: 'hasLicense("FinancialReports") && hasRole("ROLE_FINANCIAL_REPORTS")',
      dateRange: false,
    },
    {
      id: '0187b21c-1eda-4d9f-adfb-890f0fb76c57',
      legacy: 'invoice_detail',
      condition: 'hasLicense("FinancialReports") && hasRole("ROLE_FINANCIAL_REPORTS")',
    },
    {
      id: '6bad9edd-4196-4109-b551-554e1a50400c',
      legacy: 'turnover_category',
      condition: 'hasLicense("FinancialReports") && hasRole("ROLE_FINANCIAL_REPORTS")',
    },
    {
      id: 'f820fa53-1d39-4309-845b-05b5188646f4',
      legacy: 'turnover_transactionid',
      condition: 'hasLicense("FinancialReports") && hasRole("ROLE_FINANCIAL_REPORTS")',
    },
    {
      id: 'f8597e71-f437-4444-b3b3-07880c33fc74',
      legacy: 'turnover_transactionid_room',
      condition: 'hasLicense("FinancialReports") && (hasRole("ROLE_FINANCIAL_REPORTS") || hasRole("ROLE_UNIT_OWNER_REPORTS"))',
    },
    {
      id: '3108b82a-82ce-4b17-af8e-73c15051194d',
      legacy: 'turnover_reservation_room',
      condition: 'hasLicense("FinancialReports") && (hasRole("ROLE_FINANCIAL_REPORTS") || hasRole("ROLE_UNIT_OWNER_REPORTS"))',
    },
    {
      id: '80861d65-8be7-4d43-a542-c8120c24afdf',
      legacy: 'turnover_transactionid_roomtype',
      condition: 'hasLicense("FinancialReports") && hasRole("ROLE_FINANCIAL_REPORTS")',
    },
    {
      id: '06c24429-6fc1-45a8-93f7-994959b5a4c6',
      legacy: 'revenue_forecast',
      condition: 'hasLicense("FinancialReports") && hasRole("ROLE_FINANCIAL_REPORTS")',
    },
    {
      id: '0b6779dd-8a7a-434c-938f-24a15f082f85',
      legacy: 'revenue_forecast',
      condition: 'hasLicense("FinancialReports") && hasRole("ROLE_FINANCIAL_REPORTS")',
      params: {
        onlyShowNotArrivedReservations: true,
      },
    },
    {
      id: 'fc37a563-a973-467b-ac62-66dfa7286f82',
      legacy: 'revenue_forecast',
      condition: 'hasLicense("FinancialReports") && hasRole("ROLE_FINANCIAL_REPORTS")',
      params: {
        addAllRevenueOnDepartureDate: true,
      },
    },
    {
      id: 'f960f15d-aef8-4baf-9bc9-86fe2f588631',
      legacy: 'revenue_forecast',
      condition: 'hasLicense("FinancialReports") && hasRole("ROLE_FINANCIAL_REPORTS")',
      params: {
        onlyShowNotArrivedReservations: true,
        addAllRevenueOnDepartureDate: true,
      },
    },
    {
      id: 'a7d331d5-745b-41d5-bcde-4c231fdbd17c',
      legacy: 'prepayment_paid',
      condition: 'hasLicense("FinancialReports") && hasRole("ROLE_FINANCIAL_REPORTS")',
      params: {
        mode: 'Paid',
      },
    },
    {
      id: '6286a817-6213-4f31-ae99-06c124382331',
      legacy: 'prepayment_cleared',
      condition: 'hasLicense("FinancialReports") && hasRole("ROLE_FINANCIAL_REPORTS")',
      params: {
        mode: 'Cleared',
      },
    },
    {
      id: '56764d7b-09ea-4f84-8706-e6a601b2ae4f',
      legacy: 'prepayment_paid',
      condition: 'hasLicense("FinancialReports") && hasRole("ROLE_FINANCIAL_REPORTS")',
      params: {
        mode: 'Paid',
        includeReservationDetails: 1,
      },
    },
    {
      id: '2e568ca0-ccaf-454a-94f3-68a7788f5c02',
      legacy: 'prepayment_cleared',
      condition: 'hasLicense("FinancialReports") && hasRole("ROLE_FINANCIAL_REPORTS")',
      params: {
        mode: 'Cleared',
        includeReservationDetails: 1,
      },
    },
    {
      id: 'abd60a71-c439-4f9f-aa33-fad02a793028',
      legacy: 'invoice_export_report',
      condition: 'hasLicense("FinancialReports") && hasRole("ROLE_FINANCIAL_REPORTS")',
      download: true,
    },
    {
      id: '57b5d2b5-b097-4bfe-9181-a9bcda7ccae8',
      legacy: 'invoice_csv_report',
      condition: 'hasLicense("FinancialReports") && hasRole("ROLE_FINANCIAL_REPORTS")',
      download: true,
    },
    {
      id: 'f3ac8bb1-2f3d-4696-a899-c7f8089e6534',
      legacy: 'payment_csv_report',
      condition: 'hasLicense("FinancialReports") && hasRole("ROLE_FINANCIAL_REPORTS")',
      download: true,
    },
    {
      id: '96828b2f-2726-411e-8ce5-a9b9944d5512',
      legacy: 'datev_csv_export',
      condition: 'hasLicense("DatevReport") && hasRole("ROLE_HOTELMEISTER_SUPER_ADMIN")',
      download: true,
    },
    {
      id: 'f3aefe89-f823-4542-b416-4e33e0c688dd',
      legacy: 'reservation_csv_report',
      condition: 'hasLicense("FinancialReports") && hasRole("ROLE_FINANCIAL_REPORTS")',
      download: true,
    },
    {
      id: '4dbdb64b-de46-474f-a828-37bde706880d',
      legacy: 'guest_profile_export',
      condition: 'hasLicense("ExportReports")',
      dateRange: false,
      download: true,
    },
    {
      id: 'b0df1511-1ae8-41cd-958a-62c2a39c5d3e',
      legacy: 'guest_profile_export',
      condition: 'hasLicense("ExportReports")',
      dateRange: true,
      download: true,
    },
    {
      id: 'a95e65dd-4645-4da6-ad6e-29ac2d0747ef',
      legacy: 'guest_profile_export',
      condition: 'hasLicense("ExportReports")',
      dateRange: true,
      dayMonthOnly: true,
      download: true,
      params: {
        dayMonthOnly: 1,
      },
    },
    {
      id: 'ba64d31a-f654-402b-858c-57ecb5def34b',
      legacy: 'gobd_export',
      condition: 'hotelSettings.details.countryCode === "DE" && hasLicense("FinancialReports") && hasRole("ROLE_FINANCIAL_REPORTS")',
      download: true,
    },
    {
      id: 'afff0376-35df-458d-912b-936bba4a2c7d',
      legacy: 'rkv_turnover_transactionid',
      condition: 'hotelSettings.details.countryCode === "AT" && hasLicense("FinancialReports") && hasRole("ROLE_FINANCIAL_REPORTS")',
    },
    {
      id: '44294c85-9342-45c9-a702-fe024746fcf5',
      legacy: 'eu_at_rkv_dep',
      condition: 'hotelSettings.details.countryCode === "AT" && hasLicense("FinancialReports") && hasRole("ROLE_FINANCIAL_REPORTS")',
      download: true,
    },
    {
      id: '65dfd16d-8bae-4aca-86ca-0cedd3da38ee',
      legacy: 'eu_at_rksv_dep',
      condition: 'hotelSettings.details.countryCode === "AT" && hasLicense("FinancialReports") && hasRole("ROLE_FINANCIAL_REPORTS")',
      download: true,
      params: {
        rksv: '1',
      },
    },
    {
      id: '9adb8480-ad4c-41b8-989f-7edf8bd58af8',
      legacy: 'eu_at_rksv_dep_json',
      condition: 'hotelSettings.details.countryCode === "AT" && hasLicense("FinancialReports") && hasRole("ROLE_FINANCIAL_REPORTS")',
      dateRange: false,
      download: true,
    },
    {
      id: 'ce0b834c-2574-4dc6-8727-3e048653c887',
      dateRange: false,
      condition: 'hasLicense("FinancialReports") && hasRole("ROLE_FINANCIAL_REPORTS")',
    },
    {
      id: '41314176-579c-4b07-b604-9616a5bf14db',
      dateRange: true,
      condition: 'hasLicense("Reports")',
    },
    {
      id: '75b6f308-b168-46c2-81e5-4fddfd4e55ad',
      dateRange: true,
      condition: 'hasLicense("Reports")',
    },
    {
      id: '0476a476-b015-428b-aad9-ed50548048e9',
      dateRange: true,
      condition: 'hasLicense("CashBook") && hasLicense("FinancialReports") && hasRole("ROLE_FINANCIAL_REPORTS")',
    },
    {
      id: 'ee79e3ab-ed39-4a07-9346-af3822ad8a25',
      dateRange: true,
      condition: 'hasLicense("Reports")',
    },
    {
      id: 'a4707582-04d2-4780-b461-963d81be0807',
      dateRange: true,
      condition: 'hasLicense("Reports") && hasLicense("InterfaceMeldeblatt")',
    },
    {
      id: '7d8301cc-96e9-4373-ab5e-3aa8af7e6595',
      dateRange: true,
      condition: 'hasLicense("FinancialReports") && hasRole("ROLE_FINANCIAL_REPORTS")',
    },
    {
      id: '00707bf1-c458-48e6-9bfb-bf35c11b4247',
      dateRange: true,
      condition: 'hasLicense("FinancialReports") && hasRole("ROLE_FINANCIAL_REPORTS")',
    },
    {
      id: '00c74774-066f-4ef2-a469-fd19ab738d6a',
      dateRange: true,
      condition: 'hasLicense("FinancialReports") && hasRole("ROLE_FINANCIAL_REPORTS")',
    },
    {
      id: 'cc76f32b-137e-474e-8c1b-dfdd0c2d9e60',
      dateRange: 'to',
      condition: 'hasLicense("FinancialReports") && hasRole("ROLE_FINANCIAL_REPORTS")',
    },
    {
      id: 'cda39104-6dd2-46fe-8ae4-d28e37df0fe6',
      dateRange: true,
      condition: 'hasLicense("FinancialReports") && hasRole("ROLE_FINANCIAL_REPORTS")',
    },
    {
      id: '0d77e77b-9fd7-499e-ab49-64a609497f90',
      dateRange: true,
      condition: 'hasLicense("FinancialReports") && hasLicense("LinkedRooms") && hasRole("ROLE_FINANCIAL_REPORTS")',
    },
    {
      id: '3eef797d-5ab7-4ad1-a602-c45c2553f8ce',
      dateRange: true,
      condition: 'hasLicense("FinancialReports") && hasRole("ROLE_FINANCIAL_REPORTS")',
    },
    {
      id: '35f941bf-d5e7-4803-bbd5-b3732f2f50a3',
      dateRange: true,
      condition: 'hasLicense("FinancialReports") && hasLicense("LinkedRooms") && hasRole("ROLE_FINANCIAL_REPORTS")',
    },
    {
      id: 'b6ce6cad-d749-49ba-94dd-669389ffbf9d',
      dateRange: true,
      condition: 'hasLicense("Reports") && hasRole("ROLE_USER")',
    },
    {
      id: '10957dfb-1b65-4e40-9d16-ac163591a85c',
      dateRange: true,
      condition: 'hasLicense("Reports") && hasRole("ROLE_USER")',
    },
    {
      id: '3dabb362-c6f2-4811-8676-dc983d0abe38',
      dateRange: 'from',
      condition: 'hasLicense("FinancialReports") && hasRole("ROLE_FINANCIAL_REPORTS")',
    },
    {
      id: '91a7fc2f-511a-4fd6-8429-95a0984d1df2',
      dateRange: false,
      condition: 'hasLicense("Reports") && hasRole("ROLE_USER")',
      download: true,
      params: {
        accept: 'text/csv',
      },
    },
    {
      id: 'f554aa16-4958-49a6-a79a-7e95eaf7a941',
      dateRange: 'from',
      condition: 'hasLicense("Reports") && hasRole("ROLE_USER")',
      download: true,
      params: {
        accept: 'text/csv',
      },
    },
  ],
};



// WEBPACK FOOTER //
// ./src/lib/reports.js